import { render, staticRenderFns } from "./ModalSimulateQuery.vue?vue&type=template&id=bc3d2760&scoped=true"
import script from "./ModalSimulateQuery.vue?vue&type=script&lang=js"
export * from "./ModalSimulateQuery.vue?vue&type=script&lang=js"
import style0 from "./ModalSimulateQuery.vue?vue&type=style&index=0&id=bc3d2760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3d2760",
  null
  
)

export default component.exports